// Analytics tracking utility
export const trackEvent = (eventName, eventParams = {}) => {
  // Google Analytics 4
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }

  // Microsoft Clarity (custom events)
  if (typeof window !== 'undefined' && window.clarity) {
    window.clarity('event', eventName);
  }

  // Console log for debugging (remove in production if needed)
  console.log('Analytics Event:', eventName, eventParams);
};

// Predefined event trackers
export const analytics = {
  // CTA Tracking
  trackRdvClick: () => {
    trackEvent('cta_rdv_click', {
      event_category: 'engagement',
      event_label: 'Rendez-vous CTA'
    });
  },

  trackDevisClick: () => {
    trackEvent('cta_devis_click', {
      event_category: 'engagement',
      event_label: 'Devis CTA'
    });
  },

  // Chat Tracking
  trackChatStart: () => {
    trackEvent('chat_start', {
      event_category: 'engagement',
      event_label: 'Chat Assistant'
    });
  },

  trackChatQualification: (qualification) => {
    trackEvent('chat_qualification', {
      event_category: 'lead',
      event_label: 'Chat Qualified',
      ...qualification
    });
  },

  // Form Tracking
  trackFormSubmit: (formType) => {
    trackEvent('form_submit', {
      event_category: 'conversion',
      event_label: formType
    });
  },

  trackContactFormSubmit: () => {
    trackEvent('form_submit_contact', {
      event_category: 'conversion',
      event_label: 'Contact Form'
    });
  },

  trackNewsletterSubmit: () => {
    trackEvent('newsletter_subscribe', {
      event_category: 'conversion',
      event_label: 'Newsletter'
    });
  },

  // Navigation Tracking
  trackPageView: (pageName) => {
    trackEvent('page_view', {
      page_title: pageName
    });
  },

  // Diagnostic Tracking
  trackDiagnosticComplete: (result) => {
    trackEvent('diagnostic_complete', {
      event_category: 'engagement',
      event_label: 'Diagnostic Wizard',
      pack_recommended: result.pack
    });
  },

  // Custom tracking
  track: (eventName, params) => {
    trackEvent(eventName, params);
  }
};

export default analytics;
